import { Youtube } from 'lucide-react';
import { cn } from '@/lib/utils';

const HOW_TO_DOWNLOAD_URL = 'https://youtu.be/POj3KXj1JXM';

/** The walkthrough video, offered where someone is already trying to download.
 * Opens in a new tab so it never navigates away from a half-finished download. */
export default function HowToDownloadLink({
  className,
}: {
  className?: string;
}) {
  return (
    <a
      href={HOW_TO_DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline',
        className
      )}
    >
      <Youtube className="h-4 w-4 shrink-0 text-[#FF0000]" />
      How to download
    </a>
  );
}
